<template>
    <div class="bg-a-egg-f5ebdc h-screen"></div>
</template>

<script>
//config
import ConfigManager from '@/config/ConfigManager.js';
//helper
import CacheHelper from "@/helper/CacheHelper";
//mixin
import ModalMixin from '@/mixin/ModalMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin.js'
export default {
    mixins: [ModalMixin,LocaleMixin],
    data: function() {
        return {
            KEY_COOKIE_RETURN_URL: 'return_url',
        }
    },
    created: function() {
        setTimeout(()=>{
            this.modal.errorModal.clearModal()
                        .setMsg(this.lbl.shoppingcart.error_credit)
                        .show();
            this.modal.errorModal.onClose(()=> {
                this.clickGotoHome();
            })
        ,3000});
    },
    methods: {
        clickGotoHome: function() {
            let cache = new CacheHelper(ConfigManager.getCacheType());
            let cacheReturnUrl = cache.getCache(this.KEY_COOKIE_RETURN_URL);
            
            if (cacheReturnUrl) {
                cache.removeCache(this.KEY_COOKIE_RETURN_URL);
                cacheReturnUrl += "home";
                window.location.href = cacheReturnUrl;
            } else {
                window.location.href = '/home'
                //this.$router.push("/home");
            }
        },
    }

}
</script>

<style>

</style>